module.exports = __webpack_public_path__ + "media/images/features/modification/bg-question-b8e6f67031174a5e90947e6440971f83.png";